import { useEffect, useRef, useState, useCallback } from 'react';
import moment from 'moment';
import mqtt from 'mqtt';
import { consoleLog, bin2String, getMqttOptions, getNotLoginMqttOptions } from '../GlobalFunc';
import { isLogonHigh } from '../../BetSlip/LoginIBHooks';
import { useTranslation } from 'react-i18next';
import useGetToken from './useGetToken';
// import { v4 as uuidv4 } from 'uuid'
import { parseTopic as parseRCTopic } from '../../Racing/Data/useRacingPush/parseTopic';
import { gunzip } from 'react-zlib-js';

const host = window.globalConfig.PUSH_URL;
const nologinHost = window.globalConfig.PUSH_URL_NOLOGIN;
const oddsPushNoLogin = (window.globalConfig.FB_ODDS_PUSH_NO_LOGIN || window.globalConfig.RC_ODDS_PUSH_NO_LOGIN) && !window.globalConfig.IS_SPEEDBET && !window.globalConfig.IS_EWIN2

const useMqttClient = ({ globalState }) => {
    let sendLogCounter = 0;
    let sendLogInterval = window.globalConfig.SIS_SAMPLING_INTERVAL ?? 1;

    const { t, i18n } = useTranslation();
    const client = useRef(null);
    const { getAppToken, getCustomerToken } = useGetToken();
    //const [refreshToken, setRefreshToken] = useState(false);
    const clientId = useRef('');
    const savedTopics = useRef([]);
    const savedProdRef = useRef();
    const savedBSTopics = useRef([]);
    const [isPushing, setIsPushing] = useState(false);
    const isPushingRef = useRef()
    isPushingRef.current = isPushing
    const [isFBPushing, setIsFBPushing] = useState(false);
    const [isRCPushing, setIsRCPushing] = useState(false);
    const appToken = useRef("");
    const isConnectedAppToken = useRef(false);
    const isConnecting = useRef(false)
    const customerToken = useRef("");
    const isConnectedCustToken = useRef(false);
    const replayMsgQueue = useRef([]);
    const tmpMsgQueue = useRef([]);
    const tmpEsMsgQueue = useRef([]);
    const BSTmpMsgQueue = useRef([]);
    const RecoveryId = useRef()
    const pushState = useRef({
        topic: '',
        message: {}
    })
    const oldPathName = useRef('')
    const visibilityChangeRef = useRef()

    const cacheMessages = useRef({
        racing: [],
        football: [],
        betslip:[]
    })
    const cacheTraceId = useRef()
    const BSCacheTraceId = useRef()
    

    const isRacingPage = () => window.location.pathname.includes('racing');


    const esTimeoutRef = useRef();

    const enableOddsPushRef = useRef(globalState?.commonCtrl?.enableOddsPushButton)
    enableOddsPushRef.current = globalState?.commonCtrl?.enableOddsPushButton

    useEffect(()=>{
        if(client.current?.clientType =='APP' && isPushing && globalState?.commonCtrl?.enableOddsPushButton){
            setIsFBPushing(window.globalConfig.FB_ODDS_PUSH_NO_LOGIN && window.globalConfig.FB_ODDS_PUSH)
            setIsRCPushing((window.globalConfig.RC_ODDS_PUSH_NO_LOGIN || sessionStorage.getItem('lite_account_id')) && window.globalConfig.RC_ODDS_PUSH)
        }
    },[globalState?.commonCtrl?.enableOddsPushButton, isPushing])
    const getCustTokenFunc = () => {
        return customerToken.current;
    }

    const resubscribeTopic = (topics, prod) => {
        client.current?.unsubscribe(savedTopics.current);
        if (topics.length > 0) {
            console.debug('Subscribe Topics : ' + topics);
            client.current?.subscribe(topics, { qos: 0 });
        }else{
            clearMessage()
        }
        savedTopics.current = [...topics];
        savedProdRef.current = prod
    };

    const resubscribeBSTopic = (topics) => {
        const unsubTopics = savedBSTopics.current.filter(i => topics.includes(i))
        const newTopics = topics.filter(i => !savedBSTopics.current.includes(i))
        client.current?.unsubscribe(unsubTopics)
        if(newTopics.length > 0){
            replayMsgQueue.current.forEach(i => {
                if(newTopics.includes(i.topic)){
                    let idx =  BSTmpMsgQueue.current.findIndex(x=> x.topic === i.topic)
                        if(idx >= 0 ){
                            BSTmpMsgQueue.current[idx] = i;
                        }else{
                            BSTmpMsgQueue.current.push(i);
                        }
                }
            });
        }
        if (topics.length > 0) {
            console.debug('Subscribe Topics(Bet Slip): ' + topics);
            client.current?.subscribe(topics, { qos: 0 });
        }
        savedBSTopics.current = [...topics]
    }

    const pubTopic = (_topic, message, prefix, clientId) => {
        //set timeout alert
        if (_topic.indexOf('early_stlmt') >= 0 && _topic.indexOf('acpt') >= 0) {
            clearTimeout(esTimeoutRef.current);
            esTimeoutRef.current = setTimeout(() => {
                alert(t('IB_ERROR_711'));
            }, 10000);
        }

        client.current?.publish(
            _topic,
            message,
            {
                qos: 0,
                retain: false,
                properties: {
                    userProperties: {
                        SenderTimeStamp: new Date().getTime(),
                        sender_uniqueid: clientId,
                        sender_systemcode: 'JCBW',
                        sender_hostname: window.location.host,
                        event_prefix_topic: prefix
                    }
                }
            },
            function (error) {
                if (error) {
                    console.error(error);
                } else {
                    console.debug('Published:' + _topic);
                    console.debug(message);
                }
            }
        );
    };

    const subscribeCacheTopic = () => {
        let topic = `${window.bsConfig?.cacheTopics?.[client.current?.clientType == 'APP' ? 'subscribehNoLogin' : 'subscribe']}/${RecoveryId.current}`
        client.current?.unsubscribe(topic)
        console.debug('Subscribe Topics : ' + topic)
        client.current?.subscribe(topic, { qos: 0 })
    }

    // const pubCacheTopic = (topic, requestAll) => {
    //     if(!topic) return
    //     const indicator = requestAll ? 1 : 0
    //     client.current?.publish(
    //         'hk/d/prdt/wager/req/01/recovery/client',
    //         '',
    //         {
    //             qos: 0,
    //             retain: false,
    //             properties: {
    //                 userProperties: {
    //                     "sender-id": RecoveryId.current,
    //                     "recovery-topic": topic.replace(/\+/g, '*' ),
    //                     "request-all-indicator": indicator
    //                 }
    //             }
    //         },
    //         function (error) {
    //             if (error) {
    //                 console.error(error);
    //             } else {
    //                 console.debug('pubCacheTopic: ' + topic,', indicator: ' + indicator );
    //             }
    //         }
    //     );
    // }

    const pubCacheTopic= (topics, prod) => {
        if(!topics || topics.length == 0) return
        cacheTraceId.current = `${prod}_${isLogonHigh() ? sessionStorage.getItem('account') : clientId.current}_${new Date().getTime()}`
        console.debug('pubCacheTopic',topics, 'traceId' , cacheTraceId.current)
        cacheMessages.current.racing = []
        cacheMessages.current.football = []
        const body = {
            systemCode: 'JCBW2_4E',
            senderId: RecoveryId.current,
            topics: topics,
            latestMessageInSeconds: 120
        }
        const cacheTopic = window.bsConfig?.cacheTopics?.[client.current?.clientType == 'APP' ? 'publishNoLogin' : 'publish']
        client.current?.publish(
            cacheTopic,
            JSON.stringify(body),
            {
                qos: 0,
                retain: false,
                properties: {
                    userProperties: {
                        'Trace-Id' : cacheTraceId.current
                    }
                }
            },
            function (error) {
                if (error) {
                    console.error(error);
                } else {
                    console.debug('pubCacheTopic: ',topics);
                }
            }
        );
    }
    const pubBSCacheTopic= (topics) => {
        if(!topics || topics.length == 0) return
        BSCacheTraceId.current = `betslip_${isLogonHigh() ? sessionStorage.getItem('account') : clientId.current}_${new Date().getTime()}`
        console.debug('pubCacheTopic(betslip)',topics, 'traceId' , BSCacheTraceId.current)
        cacheMessages.current.betslip = []
        const body = {
            systemCode: 'JCBW2_4E',
            senderId: RecoveryId.current,
            topics: topics,
            latestMessageInSeconds: 120
        }
        const cacheTopic = window.bsConfig?.cacheTopics?.[client.current?.clientType == 'APP' ? 'publishNoLogin' : 'publish']
        client.current?.publish(
            cacheTopic,
            JSON.stringify(body),
            {
                qos: 0,
                retain: false,
                properties: {
                    userProperties: {
                        'Trace-Id' : BSCacheTraceId.current
                    }
                }
            },
            function (error) {
                if (error) {
                    console.error(error);
                } else {
                    console.debug('pubCacheTopic: ',topics);
                }
            }
        );
    }

    const pubSplunkTopic = (message, clientId) => {
        let _topic = 'hk/g/inct/log/evt/01/upd/sport_info/acty_log/init';
        //console.debug('_topic:' + _topic);
        //console.debug(message);
        client.current?.publish(
            _topic,
            message,
            {
                qos: 0,
                retain: false,
                properties: {
                    userProperties: {
                        SenderTimeStamp: new Date().getTime(),
                        sender_uniqueid: clientId,
                        sender_systemcode: 'JCBW',
                        sender_hostname: window.location.host,
                        event_prefix_topic: _topic //prefix
                    }
                }
            },
            function (error) {
                if (error) {
                    console.error(error);
                } else {
                    console.debug('Published:' + _topic);
                    console.debug(message);
                }
            }
        );
    };

    const clearMessage = () => {
        tmpMsgQueue.current = []
        tmpEsMsgQueue.current = []
        replayMsgQueue.current = []
    }

    const setPushMsg = (topic, msg, packet, isCache) => {
        const pMsgTs = packet.properties?.userProperties['p_msgTs'] || packet.properties?.userProperties['p_msgTS']
        const logMsg = window.globalConfig.pushMsgToString ? JSON.stringify(msg) : msg
        console.debug(`${pMsgTs ? `pMsgTs: ${pMsgTs} ` : ''}`,`${isCache?'cache ':''}topic`, topic, logMsg);
        let lang = i18n.language=="en" ? "en-us" : "zh-hk";

        if(msg.lang && msg.lang != lang){
            return;
        }else{
            let tmpMsg = {
                topic: topic,
                lang: msg.lang,
                message: msg,
                isCache
            };
            let isRacingTopic = topic.includes("racing");
            let isFBCrdTopic = topic.includes("crd/fb")
            let requestAll = false;
            if(isRacingTopic){
                let topicInfo = parseRCTopic(topic);
                if(topicInfo.raceStatus || (topicInfo.pmPoolStatus && !topicInfo.isPoolInv && !topicInfo.isOdds) || topicInfo.displayType == "detail"){
                    requestAll = true;
                }
            }
            if(isFBCrdTopic){
                requestAll = true;
            }
            let idx =  tmpMsgQueue.current.findIndex(x=> x.topic===topic && (!x.lang || x.lang==lang));
            let replayIdx =   replayMsgQueue.current.findIndex(x=> x.topic===topic && (!x.lang || x.lang==lang))
            if( !requestAll && isCache && ((replayIdx >= 0 && !replayMsgQueue.current[replayIdx].isCache) || (idx >=0 && !tmpMsgQueue.current[idx].isCache))) return

            if(topic.indexOf('early_stlmt') >= 0){
                let idx =  tmpEsMsgQueue.current.findIndex(x=> x.topic===topic );
                if ( idx >=0 ) {
                    tmpEsMsgQueue.current[idx] = tmpMsg;
                } else {
                    tmpEsMsgQueue.current.push(tmpMsg);
                }
            }
            if ( !requestAll && idx >=0 ) {
                tmpMsgQueue.current.splice(idx,1);
            }
            tmpMsgQueue.current.push(tmpMsg);
            if(savedBSTopics.current.includes(topic)){
                let idx =  BSTmpMsgQueue.current.findIndex(x=> x.topic===topic)
                if(idx >= 0 ){
                    BSTmpMsgQueue.current[idx] = tmpMsg;
                }else{
                    BSTmpMsgQueue.current.push(tmpMsg);
                }
            }
            savePushMsg(topic, msg, requestAll, isCache);
        }

    };

    const setCacheMsg = ( decoded, packet, prod) =>{
        var plain = bin2String(decoded);
        if(plain.length > 0){
            let data = JSON.parse(plain);
            let seq = parseInt(packet.properties?.userProperties['msg-seq'])
            let total = parseInt(packet.properties?.userProperties['msg-total'])
            if(!cacheMessages.current[prod]) cacheMessages.current[prod] = []
            cacheMessages.current[prod][seq - 1] = data
            let isEnd =  cacheMessages.current[prod].filter(i => i).length === total
            if(isEnd){
                let currentCacheMsg = []
                cacheMessages.current[prod].forEach(item =>{
                    currentCacheMsg  = [...currentCacheMsg, ...item.messages]
                })

                console.debug(`Cache Messages: ${currentCacheMsg?.length}`)
                if(prod == 'racing'){
                    currentCacheMsg = currentCacheMsg.reverse()
                }
                currentCacheMsg.forEach(item =>{
                    if(!item) return
                    let curTopic = item['msg-topic']
                    let message = item['msg-data']
                    setPushMsg(curTopic, message, packet, true);
                })
                cacheMessages.current[prod] = []
            }
        }
    }

    const savePushMsg = (topic, message, requestAll, isCache) => {
        const updTime = moment()
        const msgCacheItem = {topic, message, updTime, isCache}
        let lang = i18n.language=="en" ? "en-us" : "zh-hk";
        let idx = replayMsgQueue.current.findIndex(x=> x.topic===topic && (!x.lang || x.lang==lang));
        if ( !requestAll && idx>=0 ) {
            replayMsgQueue.current.splice(idx,1)
        }
        replayMsgQueue.current.push(msgCacheItem);
    }

    const messageCallback = (topic, message, packet) => {
        try{
            if(topic.includes('wager/rpy/01/recovery') || topic.includes('wager/rpy/02/recovery')){
                if(parseInt(packet.properties?.userProperties['payload-size']) > 0){
                    if(cacheTraceId.current != packet.properties?.userProperties['Trace-Id'] &&  packet.properties?.userProperties['Trace-Id'] != BSCacheTraceId.current) return
                    gunzip(message, (err, decoded) => {
                        let prod = cacheTraceId.current.split('_')[0]
                        setCacheMsg(decoded, packet, prod);
                    });
                }
            }
            else if (topic.indexOf('early_stlmt') >= 0) {
                if (topic.indexOf('acpt') >= 0) {
                    clearTimeout(esTimeoutRef.current);
                }
                var plain = bin2String(message);
                if(plain.length > 0){
                    let msg = JSON.parse(plain);
                    setPushMsg(topic, msg, packet);
                }
            } else {
                gunzip(message, (err, decoded) => {
                    let plain
                    if(decoded){
                        plain = bin2String(decoded);
                    }
                    if(err){
                        plain = bin2String(message);
                    }
                    if(plain.length > 0){
                        let msg = JSON.parse(plain);
                        setPushMsg(topic, msg, packet);
                    }
                    if (sendLogCounter % sendLogInterval === 0) {
                        const currentDateTime = new Date();
                        currentDateTime.setHours(currentDateTime.getHours() + 8);
                        const formattedCurrentDateTime = currentDateTime.toISOString().replace('Z', '+08:00');
                        let body = {
                            "receivedTime": formattedCurrentDateTime,
                            "activityID": packet?.properties?.userProperties?.activityID || packet?.properties?.userProperties?.p_trcId,
                            "entityID": packet?.properties?.userProperties?.entityID || packet?.properties?.userProperties?.p_etyId,
                            "eventType": packet?.properties?.userProperties?.eventType || packet?.properties?.userProperties?.p_evtAct,
                            "trackingID": packet?.properties?.userProperties?.trackingID || packet?.properties?.userProperties?.p_intId,
                            "system": "JCBW2",
                            "topic": topic,
                            "webHashID": sessionStorage.getItem('hWebID') || ""
                        };

                        let clientId = sessionStorage.getItem('session_id') ?
                        'jcbw2_4e_' + Math.random().toString(16).substring(2, 8) :
                        'jcbw2_4e_' + sessionStorage.getItem('account') +'_' + new Date().getTime();
                        pubSplunkTopic(JSON.stringify(body), clientId);
                        sendLogCounter = 1;
                    } else {
                        sendLogCounter += 1;
                    }

                });
            }
        }
        catch (e) {
            console.error(e, e.stack);
        }
    };

    const connectMqttWithCustomerToken = useCallback(() => {
        if ( customerToken.current != '' && customerToken.current != null) {
            //clientId.current = 'jcbw2_4e_' + Math.random().toString(16).substring(2, 8);
            clientId.current = 'jcbw2_4e_' + sessionStorage.getItem('account') + '_'  + new Date().getTime();
            RecoveryId.current = 'jcbw2_4e_' + sessionStorage.getItem('account') + '_'+ new Date().getTime()
            let c = mqtt.connect(host, getMqttOptions(clientId.current, true, customerToken.current));

            c.on('message', messageCallback);

            c.on('error', (err) => {
                console.debug('Connection error (Cust): ', err);
                isConnectedCustToken.current = false;
                isConnecting.current = false
                setIsPushing(false);
                setIsFBPushing(false)
                setIsRCPushing(false)
                c.end();
            });

            c.on('connect', () => {
                console.debug('Client connected (Cust):' + clientId.current);
                isConnectedCustToken.current = true;
                isConnecting.current = false
                subscribeCacheTopic()
                setIsPushing(true);
                setIsFBPushing(window.globalConfig.FB_ODDS_PUSH &&  enableOddsPushRef.current)
                setIsRCPushing(window.globalConfig.RC_ODDS_PUSH &&  enableOddsPushRef.current)
            });

            c.on('reconnect', () => {
                isConnecting.current = true
                console.debug('Reconnecting(Cust)...');
            });

            c.on('close', () => {
                console.debug('Client disconnected (Cust):' + clientId.current);
                isConnectedCustToken.current = false;
                clearMessage()
                setIsPushing(false);
                setIsFBPushing(false)
                setIsRCPushing(false)
            });

            client.current = c;
            client.current.clientType = 'CUST'
        }
    },[])

    const connectMqttWithAppToken = useCallback(() => {
            clientId.current =  'jcbw2_4e_' + Math.random().toString(16).substring(2, 8)+'_'+ new Date().getTime();
            RecoveryId.current = 'jcbw2_4e_' + Math.random().toString(16).substring(2, 8)+'_'+ new Date().getTime()
            let c = mqtt.connect(nologinHost, getNotLoginMqttOptions(clientId.current, appToken.current));

            c.on('message', messageCallback);

            c.on('error', (err) => {
                console.debug('Connection error (App): ', err);
                isConnectedAppToken.current = false;
                isConnecting.current = false
                setIsPushing(false);
                setIsFBPushing(false)
                setIsRCPushing(false)
                c.end();
            });

            c.on('connect', () => {
                console.debug('Client connected (App):' + clientId.current);
                isConnectedAppToken.current = true;
                isConnecting.current = false
                setIsPushing(true);
                subscribeCacheTopic()
            });

            c.on('reconnect', () => {
                isConnecting.current = true
                console.debug('Reconnecting(App)...');
            });

            c.on('close', () => {
                console.debug('Client disconnected (App):' + clientId.current);
                isConnectedAppToken.current = false;
                clearMessage()
                setIsPushing(false);
                setIsFBPushing(false)
                setIsRCPushing(false)
            });

            client.current = c;
            client.current.clientType = 'APP'
    },[])

    const disconnectPush = () => {
        isConnecting.current = false
        client.current?.end();
        client.current?.off('message', messageCallback);
    }

    const isPushPage = () => {
        return window.location.pathname.toLowerCase().indexOf("/football/")>=0 && window.globalConfig.FB_ODDS_PUSH
             || window.location.pathname.toLowerCase().indexOf("/racing/")>=0 && window.globalConfig.RC_ODDS_PUSH;
    }

    const isConnected = () => {
        let isLogon = isLogonHigh();
        return (isLogon && isConnectedCustToken.current) || ((!isLogon || window.BetLiteSite) && isConnectedAppToken.current)
    }

    // useEffect(() => {
    //     if(oldPathName.current != window.location.pathname){
    //         if ( isPushPage() ) {
    //             if ( !isConnected() ) {
    //                 refreshTokenAndConnect();
    //             }
    //         }
    //         else {
    //             disconnectPush();
    //         }
    //     }
    //     oldPathName.current = window.location.pathname
    // }, [window.location.pathname]);

    useEffect(() => {
        if ( isLogonHigh() ) {
            if ( client.current?.clientType == 'APP' && !window.BetLiteSite) {
                disconnectPush();
            }
            if ( !isConnected() && !isConnecting.current) {
                refreshTokenAndConnect();
            }
        }
        else {
            if ( client.current?.clientType == 'CUST'  || !oddsPushNoLogin || !isRacingPage()) {
                disconnectPush();
            }
            if ( !isConnected() && !isConnecting.current ) {
                refreshTokenAndConnect();
            }
        }
    }, [isLogonHigh(), window.location.pathname]);

    // for refreshToken
    useEffect(()=> {
        const timer = setInterval(() => {
            if(client.current?.clientType == 'CUST'){
                disconnectPush();
                refreshTokenAndConnect();
            }
        }, 10 * 60 * 1000);
        document.addEventListener("visibilitychange", visibilityChange);
        return () => {
            clearInterval(timer);
            document.removeEventListener("visibilitychange", visibilityChange);
        }
    },[]);

    const visibilityChange = () =>{
        if(document.hidden){
            if(client.current?.clientType == 'APP'){
                visibilityChangeRef.current = setTimeout(()=>{
                    disconnectPush()
                },(window?.globalConfig?.MQTT_INACTIVE_DISCONNECT_TIME || 30000))
            }
        }else if(!document.hidden){
            clearTimeout(visibilityChangeRef.current)
            if(!isPushingRef.current){
                refreshTokenAndConnect()
            }else{
                replayMsgQueue.current = []
            }
        }
    }

    const refreshTokenAndConnect = () => {
        if(isConnecting.current) return
        // Lite acc
        if (window.BetLiteSite) {
            // lite account only has racing
            isConnecting.current = true
            connectMqttWithAppToken(nologinHost);
        }

        // SP4e
        if (isLogonHigh()) {
            isConnecting.current = true
            if ( window.globalConfig.useArkleAccessTokenInSolace && window.sessionStorage.getItem('access_token')!="OLD_AUTHENT" ) {
                customerToken.current = window.sessionStorage.getItem('access_token');
                try {
                    connectMqttWithCustomerToken();
                } catch(err) {
                    isConnecting.current = false
                    console.error(err);
                }
            }
            else {
                getCustomerToken().then((data) => {
                    consoleLog('refresh cust token', data?.access_token);
                    customerToken.current = data?.access_token;
                    connectMqttWithCustomerToken();
                }).catch((err)=>{
                    isConnecting.current = false
                    console.error(err);
                })
            }
        } else if (oddsPushNoLogin && isRacingPage()) {
            isConnecting.current = true
            connectMqttWithAppToken(nologinHost);
        }
    };

    return { client,
        pushState,
        isPushing,
        isFBPushing,
        isRCPushing,
        resubscribeTopic,
        pubTopic,
        pubCacheTopic,
        pubBSCacheTopic,
        getCustTokenFunc,
        clientId,
        tmpMsgQueue,
        tmpEsMsgQueue,
        replayMsgQueue,
        clearMessage,
        resubscribeBSTopic,
        BSTmpMsgQueue
    };
};

export default useMqttClient;
